export default __webpack_public_path__ + "static/media/LMS.4cef5068.png";